export const USER_LOGIN = 'states/auth/USER_LOGIN';
export const USER_LOGOUT = 'states/auth/USER_LOGOUT';